import { Routes, Route, Navigate } from 'react-router-dom';
import { auth } from './firebase';
import { onAuthStateChanged } from 'firebase/auth';
import { Suspense, lazy, useState, useEffect } from 'react';
import { ToastContainer } from 'react-toastify';
import { useTheme } from './theme/ThemeContext';

const LandingPage = lazy(() => import('./pages/Landing'));
const HomePage = lazy(() => import('./pages/Home'));

function App() {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const { theme } = useTheme();

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (currentUser) => {
      setUser(currentUser || null);
      setLoading(false);
    });
    return () => unsubscribe();
  }, []);

  if (loading) {
    return (
      <div className="min-h-screen bg-gray-900 flex items-center justify-center">
        <div className="text-purple-400 text-2xl">Loading...</div>
      </div>
    );
  }

  return (
    <>
      <Suspense
        fallback={(
          <div className="min-h-screen bg-gray-900 flex items-center justify-center">
            <div className="text-subtle">Loading page...</div>
          </div>
        )}
      >
        <Routes>
          <Route
            path="/"
            element={user ? <Navigate to="/app" /> : <LandingPage />}
          />
          <Route
            path="/app"
            element={user ? <HomePage /> : <Navigate to="/" />}
          />
        </Routes>
      </Suspense>
      <ToastContainer
        position="bottom-right"
        autoClose={3000}
        theme={theme}
      />
    </>
  );
}

export default App;
